import { ModuleWithProviders, NgModule } from '@angular/core';
import { NavModule, NavSidebarServiceToken, NavModuleConfigToken } from '@mt-ng2/nav-module';
import { NavSidebarService } from './sidebar.service';
import { RegistrationRequestsNavComponent } from './registration-requests-nav.component'
import { WalkInOrdersNavComponent } from './walk-in-orders-nav.component';
import { RouterModule } from '@angular/router';
import { FulfillmentReportNavComponent } from './fulfillment-report-nav.component';
import { CommonModule } from '@angular/common';
import { NavConfigOverride } from '../common/configs/nav.config';

@NgModule({
    exports: [NavModule],
    imports: [NavModule, RouterModule, CommonModule],
    declarations: [RegistrationRequestsNavComponent, WalkInOrdersNavComponent, FulfillmentReportNavComponent]
})
export class AppNavModule {
    static forRoot(): ModuleWithProviders<AppNavModule> {
        return {
            ngModule: AppNavModule,
            providers: [
                { provide: NavSidebarServiceToken, useClass: NavSidebarService }, 
                { provide: NavModuleConfigToken, useValue: NavConfigOverride },
                NavSidebarService
            ],
        };
    }
}
